import React from 'react';

const VersionInfo = () => {
  return (
    <>
      <p>{process.env.REACT_APP_GIT_SHA || 'Couldnt get version info'}</p>
    </>
  );
};

export default VersionInfo;
